import * as React from 'react';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import {
  Card,
  Table,
  Stack,
  Box,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  Avatar,
  TableHead,
  TextField,
  MenuItem,
  Divider,
  Rating,
  Grid,
  Tooltip
} from '@mui/material';
import Label from 'src/components/Label';
import { LoadingButton } from '@mui/lab';
import pallete from '../theme/palette';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead } from '../sections/@dashboard/user';
import { api } from '../Api';
import OrderDetailModal from 'src/sections/@dashboard/orders/OrderDetailModal';
import ChangeOrderStatus from 'src/sections/@dashboard/orders/ChangeOrderStatus';
import { Link as RouterLink } from 'react-router-dom';
import AddAdminModal from 'src/sections/@dashboard/user/AddAdminModal';
import ProtectionFeeModal from 'src/sections/@dashboard/ProtectionFee/ProtectionFeeModal';
import { Encryption } from 'src/functions/function';

export default function ProtectionFee() {
  const TABLE_HEAD = [
    { id: 'minprice', label: 'Min Price (LKR)', alignRight: false },
    { id: 'maxprice', label: 'Max Price (LKR)', alignRight: false },
    { id: 'vintit', label: 'Fix Price (LKR)', alignRight: false },
    { id: 'protection', label: 'Percentage (%)', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: 'action', label: 'Action', alignRight: false }
  ];

  const [search, setsearch] = useState('');
  const [searchLoading, setsearchLoading] = useState(false);
  const tableRef = React.createRef();
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);
  //   const [list, setlist] = useState([]);
  const [detail, setDetail] = React.useState(null);
  const [loading, setloading] = useState(true);
  const [sorting, setsorting] = useState('');
  const [Addopenmodal, setAddOpenModal] = useState(false);
  const [buyerlist, setbuyerlist] = useState([]);
  const [sortinglist, setsortinglist] = useState([
    { id: 1, name: 'Date Placed (Newest First)' },
    { id: 2, name: 'Date Placed (Oldest First)' },
    { id: 3, name: 'No. of Items (Ascending)' },
    { id: 4, name: 'No. of Items (Descending)' }
  ]);

  const [status, setStatus] = useState('');
  const [statuslist, setstatuslist] = useState([
    { id: 1, name: 'Placed' },
    { id: 2, name: 'Processed' },
    { id: 3, name: 'Shipped' },
    { id: 4, name: 'Delivered' },
    { id: 5, name: 'Completed' },
    { id: 6, name: 'Cancelled' }
  ]);

  const [permission, setpermission] = useState([]);
  const requirement = ['visible', 'add', 'edit', 'delete', 'change status'];
  function checkRender() {
    let check = 'buyer protection fee';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item?.permission_name?.toLowerCase() == check
    );
    localPerm[0].permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    if (search.length == 0) {
      buyerlist.length = 0;
      handlegetProtection(page);
    }
  }, [search]);

  useEffect(() => {
    checkRender();
  }, []);

  const handleAdditemCloseModal = () => setAddOpenModal(false);

  const handlePageChange = (event, value) => {
    buyerlist.length = 0;
    setPage(value);
    handlegetProtection(value);
  };

  function handlegetProtection(page) {
    setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    let url = api.get_buyer_protection_fee;
    const params = new URLSearchParams();
    const searchParam =
      search.length > 0 ? Encryption(search, process.env.REACT_APP_SECRET_KEY) : null;
    const pageParam = page ? Encryption(page, process.env.REACT_APP_SECRET_KEY) : null;

    if (searchParam) params.append('search', searchParam);
    if (pageParam) params.append('page', pageParam);
    // if (search) params.append('search', search);
    if (params.toString()) url += `?${params.toString()}`;

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    // console.log('parms', params);
    fetch(url, requestOptions)
      .then((response) => {
        // console.log('')
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to protection fee');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        console.log('result', result?.data);
        setbuyerlist(result?.data);
        setsearchLoading(false);
        result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
      })
      .catch((error) => {
        console.log('error', error);
        setpagesCount(0);
        setbuyerlist([]);
      })
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  function handleDeleteProtection(id) {
    console.log('delete id of buyer protection', id);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'Delete',
      headers: myHeaders,
      redirect: 'follow'
    };
    // console.log('parms', params);
    fetch(api.delete_buyer_protection_fee + '?id=' + id, requestOptions)
      .then((response) => {
        // console.log(response.status, '');
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to protection fee');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        buyerlist.length = 0;
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => { });
  }

  useEffect(() => {
    handlegetProtection();
  }, []);

  const refreshAdmin = () => {
    buyerlist.length = 0;
    handleAdditemCloseModal();
    handlegetProtection();
  };

  function openProtectionModal(item) {
    setAddOpenModal(true);
    setDetail(item);
  }

  const isDataFound = buyerlist.length === 0;

  return (
    <Page title={`Buyer Protection Fee | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* AddAdminModal */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={Addopenmodal}
          onClose={handleAdditemCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1
            }}
          // className="admin_modal_pa"
          >
            <ProtectionFeeModal
              protection={detail}
              handleClose={handleAdditemCloseModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Buyer Protection Fee
          </Typography>
          {permission?.includes('add') && (
            <Button
              onClick={() => openProtectionModal(null)}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              Add
            </Button>
          )}
        </Stack>

        <Card>
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between'
            }}
            className="top_options"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              placeholder="Search"
              onClickSearch={() => {
                setsearchLoading(true);
                handlegetProtection();
                setPage(1);
                buyerlist.length = 0;
              }}
              onEnter={() => {
                setsearchLoading(true);
                handlegetProtection();
                setPage(1);
                buyerlist.length = 0;
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              loading={searchLoading}
              variant="contained"
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                // getOrders(1);
                handlegetProtection();
                buyerlist.length = 0;
              }}
              className="width_full"
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
          <TableContainer sx={{ minWidth: 800 }}>
            <Scrollbar>
              <Table ref={tableRef}>
                <UserListHead headLabel={TABLE_HEAD} rowCount={TABLE_HEAD.length} />
                <TableBody>
                  {buyerlist.map((item) => {
                    const { status } = item;
                    return (
                      <TableRow>
                        {/* NAME */}
                        <TableCell scope="row" padding="normal" style={{ width: 170 }}>
                          <Typography fontSize={12} variant="subtitle2" style={{}}>
                            {(item && item?.min_price) || 'N/A'}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2" style={{}}>
                            {(item && item?.max_price) || 'N/A'}
                          </Typography>
                        </TableCell>

                        <TableCell align="left" scope="row" padding="normal" style={{ width: 200 }}>
                          <Typography fontSize={12} variant="subtitle2">
                            {(item && item.fixed_amount) || 'N/A'}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {(item && item?.percentage) || 'N/A'}
                          </Typography>
                        </TableCell>

                        {/* STATUS */}
                        <TableCell align="left" style={{ maxWidth: 150 }}>
                          <Label
                            style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                            variant="ghost"
                            color={(status === 'Declined' && 'error') || 'success'}
                          >
                            <Typography
                              style={{
                                textTransform: 'capitalize',
                                fontWeight: 'bold',
                                fontSize: 12
                              }}
                            >
                              {status}
                            </Typography>
                          </Label>
                        </TableCell>
                        {/* ACTIONS */}
                        <TableCell style={{ position: 'relative', minHeight: 400 }}>
                          <Box
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start'
                            }}
                          >
                            {permission.includes('edit') && (
                              // <Button
                              //   startIcon={
                              //     <Iconify color={pallete.primary.main} icon="solar:user-id-bold" />
                              //   }
                              //   onClick={(event) => {
                              //     event.preventDefault();
                              //     event.stopPropagation();

                              //     openProtectionModal(item);
                              //   }}
                              //   variant="outlined"
                              //   size="small"
                              //   color="primary"
                              //   component={RouterLink}
                              //   to="#"
                              //   style={{
                              //     justifyContent: 'flex-start',
                              //     marginTop: 5,
                              //     width: 135
                              //   }}
                              // >
                              //   edit
                              // </Button>
                              <Tooltip title="Edit">
                                <LoadingButton
                                  size="small"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    openProtectionModal(item);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  component={RouterLink}
                                  to="#"
                                >
                                  <Iconify style={{ cursor: 'pointer', fontSize: 20 }} icon="solar:user-id-bold" />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('delete') && (
                              // <Button
                              //   size="small"
                              //   onClick={() => handleDeleteProtection(item.id)}
                              //   style={{
                              //     justifyContent: 'flex-start',
                              //     marginTop: 5,
                              //     width: 135
                              //   }}
                              //   variant="outlined"
                              //   component={RouterLink}
                              //   to="#"
                              //   startIcon={
                              //     <Iconify
                              //       color={pallete.primary.main}
                              //       icon="material-symbols:delete"
                              //     />
                              //   }
                              // >
                              //   Delete
                              // </Button>
                              <Tooltip title="Delete">
                                <LoadingButton
                                  size="small"
                                  onClick={() => handleDeleteProtection(item.id)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  // loading={selectedId == id}
                                  component={RouterLink}
                                  to="#"
                                >
                                  <Iconify style={{ cursor: 'pointer', fontSize: 20 }} icon="material-symbols:delete" />
                                </LoadingButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isDataFound && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </Scrollbar>
          </TableContainer>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
